import { createClient } from '@supabase/supabase-js';

// Access environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create a single supabase client for interacting with your database
let supabaseInstance;

if (supabaseUrl && supabaseAnonKey) {
  supabaseInstance = createClient(supabaseUrl, supabaseAnonKey);
} else {
  console.warn('Supabase credentials missing. App will work in read-only/offline mode.');
  // Mock client to prevent crash
  supabaseInstance = {
    from: () => ({
      insert: () => Promise.resolve({ error: { message: 'Supabase not configured. Check your .env file.', code: 'MISSING_CONFIG' } }),
      select: () => Promise.resolve({ data: [], error: null })
    })
  };
}

export const supabase = supabaseInstance;
